import React from 'react';

import LoadingIndicator from 'generic/LoadingIndicator.react';

import {ErrorRetryState} from '../../components/ErrorRetryState';
import {ClassSettingsForm} from './ClassSettingsForm';
import {useClassSettings} from './useClassSettings';

interface Props {
  classroomId: string;
}

// v2 Settings tab: owns the classroom subscription + mutations (useClassSettings) and renders the
// RHF - Replaces the legacy Flux-store TeacherClassroomSettings.
export const Settings = ({classroomId}: Props) => {
  const settings = useClassSettings(classroomId);

  if (!settings.isReady) {
    return <LoadingIndicator />;
  }

  if (settings.hasError || typeof settings.classroom?.getId !== 'function') {
    return (
      <div className='pt-x4'>
        <ErrorRetryState
          copy='We couldn’t load this class’s settings.'
          onRetry={settings.reload}
        />
      </div>
    );
  }

  return (
    <div className='pt-x4'>
      <ClassSettingsForm settings={settings} />
    </div>
  );
};
